import HalspanContainer from '@components/Container'
import RibbonTemplate from '@components/RibbonTemplate'
import { useStoreNavigation } from '@components/StoreNavigationProvider'
import branding from '@config/branding'
import FormManager from '@whitecobalt/tungsten/esm/components/FormManager'
import Lazyload from '@whitecobalt/tungsten/esm/components/Lazyload'
import Icon from '@whitecobalt/tungsten/esm/components/Icon'
import browserAgent from '@whitecobalt/tungsten/utils/browserAgent'
import React, { useRef, useState } from 'react'
import { FormControl, InputGroup, Row } from 'react-bootstrap'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import  useWindowDimensions  from '@utils/getWindowDimensions'
import './index.scss'

interface ProductListContainerProps {
    
}

const ProductListContainer: React.FunctionComponent<ProductListContainerProps> = ({children}) => {
    const storenav = useStoreNavigation()
    const location = useLocation()
    const history = useHistory()
    const matches = useRouteMatch<{searchText: string}>('/store/search/:searchText')
    const substr = "https://hub.halspan.com".length
    const [ hoveredNav, setHoveredNav ] = useState<string| undefined>(undefined);
    const { height, width } = useWindowDimensions();

    return (
        <HalspanContainer 
            id="store-search" 
            bannerBackground="/images/store-banner.png"
            bannerRaw={(
                <>
                    <div className="halspan-banner-ribbon">
                        <RibbonTemplate 
                        logo="/images/halspan-store.png" 
                        title={<span>Halspan<span className="sub">®</span> Store </span>}  />
                    </div>
                    <FormManager onSubmit={(event) => {
                        const FORM_DATA = event.json()
                        if(!!FORM_DATA.searchText) {
                            history.push(`/store/search/${FORM_DATA.searchText}`)
                        }
                    }}>
                        <InputGroup>
                            <FormManager.Input
                                stripped
                                name="searchText"
                                value={matches?.params?.searchText || undefined}
                                placeholder="Search Store..."
                                aria-label="Search Store..."
                                aria-describedby="search"
                                />
                            <InputGroup.Text id="search"><Icon name="search" className="clickable" onClick={() => document.getElementById('submit-search')?.click()}/></InputGroup.Text>
                        </InputGroup>
                        <button type="submit" className="d-none" id="submit-search"></button>
                    </FormManager>
                </>
            )}>
            <div className={"product-list-container nav-container " + (width < 759 ? 'mobileViewNavbar':'' )}>
                <Navbar variant="light" expand="md">
                    {width >= 759 && (
                        <>
                            <Navbar.Toggle aria-controls="navbar-dark-example" />
                        </>
                    )}
                    <Navbar.Collapse id="navbar-dark-example" className={width < 759 ? 'show pt-1':'pt-1'}>
                        <Nav>
                            {storenav.menu.map((each: any, index) => {
                                const parentURL = each.url.substr(substr)
                                return each.items.length > 0 ? (
                                    <NavDropdown
                                        key={each.title + index}
                                        id={each.title}
                                        title={each.title}
                                        show={width >= 759 ? hoveredNav === each.title : undefined }
                                        active={parentURL === location.pathname || location.pathname.includes(parentURL)}
                                        onClick={()=> !(parentURL === location.pathname || location.pathname.includes(parentURL)) && width >= 759 && history.push(parentURL)}
                                        onMouseEnter={(e:any)=>{setHoveredNav(e?.target?.id)}}
                                        onMouseLeave={(e:any)=>{setHoveredNav(undefined)}}
                                        className={width < 759 ? "navbar-dropdown-items": ""}
                                    >
                                        {browserAgent.mobile && (
                                            <NavDropdown.Item 
                                                as={Link} 
                                                to={parentURL} 
                                                active={parentURL === location.pathname}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    return width >= 759 ? history.push(parentURL) : undefined
                                                }}
                                                >
                                                All 
                                            </NavDropdown.Item>
                                        )}
                                        {each.items.map((item: any, index: number) => {
                                            const navURL = item.url.substr(substr)
                                            return (
                                                <NavDropdown.Item 
                                                    key={index} as={Link} 
                                                    to={navURL} 
                                                    active={navURL === location.pathname}
                                                    onClick={(e)=> {
                                                        e.stopPropagation();
                                                        return width >= 759 ? history.push(navURL) : undefined
                                                    }}
                                                    >
                                                    {item.title}
                                                </NavDropdown.Item>
                                            )
                                        })}
                                    </NavDropdown>
                                ) : (
                                    <Nav.Link className={width < 759 ? "navbar-dropdown-items": ""} key={each.title} as={Link} to={parentURL} active={parentURL === location.pathname}>{each.title}</Nav.Link>
                                )
                            })}
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
            </div>
			<div className="product-list-container">
                <Lazyload.Container>
                    {children}
                </Lazyload.Container>
            </div>
        </HalspanContainer>
    )
}

export default ProductListContainer
